import React from "react";
import { NaverTitle } from "../../../components/title/Title";
import arrowBack from "static-file/images/arrowBack.png";
import { PageTitleContainer, BizContainer, BizAlertContainer } from "../../../components/common";
import { Button } from "components/ui/Button";
import alertIcon from "static-file/images/alertIcon.png";
import { AlertItem } from "../../../components/common/AlertItem";
import Text from "components/ui/Text";
import { useNaverLogin } from "views/naver/hooks/useNaverLogin";


export const ShopNotExistView = (rootStore: any) => {
  const { naverLogout } = useNaverLogin(rootStore);

  const handleGoToLogin = () => {
    naverLogout({
      clientId: process.env.REACT_APP_NAVER_CLIENT_ID!,
      redirectUri: `${window.location.origin}/okgo/naver/logout`,
    });
  };

  const handleNaverJoin = () => {
    window.open("https://new.smartplace.naver.com", "_blank");
  };

  return (
    <>
      <PageTitleContainer>
        <NaverTitle
          title="연동할 매장이 없어요"
          subTitle="입력하신 네이버 스마트 플레이스 아이디로 등록된 네이버 주문 매장이 없어요"
        />
      </PageTitleContainer>

      <BizContainer>
        <BizAlertContainer>
          <div className="flex items-center gap-2">
            <img src={alertIcon} alt="alertIcon" />
            <Text fontSize={17} fontWeight={600} color="#3F3F46">
              확인해주세요
            </Text>
          </div>
          <AlertItem text="입력하신 네이버 아이디가 네이버 예약/주문 매장이 등록된 계정이 맞는지 확인해주세요." />
          <AlertItem text="네이버 예약/주문 매장이 네이버페이 가입 절차 진행 중인 경우, 매장 목록에 노출되지 않습니다." />
          <AlertItem text="매장에서 네이버 예약/주문을 이용하지 않는 경우, 네이버 예약/주문서비스 입점 후 배달매니저와 연동을 진행해주세요." />
        </BizAlertContainer>
      </BizContainer>

      <div className="pt-6 pb-6 flex justify-between">
        <Button
          fullWidth={false}
          variant="secondaryLight"
          size="sm"
          padding="12px 16px"
          className="flex align-middle gap-2"
          onClick={handleGoToLogin}
        >
          <img src={arrowBack} alt="arrowBack" />
          <span>로그인 화면으로 이동</span>
        </Button>
        <Button fullWidth={false} variant="primaryWhite" size="sm" padding="12px 16px" onClick={handleNaverJoin}>
          네이버 입점하기
        </Button>
      </div>
    </>
  );
};
